import gql from "graphql-tag";
const ADD_NEWSLETTER = gql `
  mutation addNewsletter($newsletterAddInput: NewsletterAddInput!) {
    addNewsletter(newsletterAddInput: $newsletterAddInput) {
      id
    }
  }
`;
export default ADD_NEWSLETTER;
